import styled from 'styled-components';
const S = {};

S.ModalBackground = styled.div`
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

S.ModalWrapper = styled.div`
  position: relative;
  z-index: 99;
  overflow: auto;
  margin: 0 0.5rem;
  width: ${({ width }) => width || '100%'};
  border-radius: ${({ borderRadius }) => borderRadius || ''};
  padding: ${({ padding }) => padding || ''};
  background-color: #fff;
`;

S.ModalHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ headerPadding }) => headerPadding || '0.9375rem 0 1.0625rem 0'};
  background-color: ${({ backgroundHeader }) => backgroundHeader || '#fff'};
  color: ${({ color }) => color || ''};
`;

S.CmsBanner = styled.div`
  position: absolute;
  right: 100%;
  height: 100%;
  width: 300px;
`;

S.ModalTitle = styled.h2`
  margin: 0;
  padding: 0 0 0 10px;
  font-size: ${({ fontSize }) => fontSize || '1.5rem'};
  font-weight: 800;
  text-align: center;
  color: ${({ titleColor }) => titleColor || '#000'};
`;

S.HeaderIconContainer = styled.div`
  width: ${({ titleIconWidth }) => (titleIconWidth === null ? '' : titleIconWidth || '2.5rem')};
  height: ${({ titleIconHeight }) => (titleIconHeight === null ? '' : titleIconHeight || '2.5rem')};
  color: ${({ titleColor }) => titleColor || '#3B3B3B'};
  svg{
      path{
        fill:${({titleColor})=> (titleColor!=null) ? `${titleColor} !important`: '#3B3B3B'};
      }
  }
`;

S.CloseIconContainer = styled.div`
  position: absolute;
  right: 1.625rem;
  top: 50%;
  padding: 0;
  width: 1.4375rem;
  height: 1.4375rem;
  transform: translateY(-50%);
  line-height: 1;
  bottom: 0;
  background-size: 1.47rem 1.47rem;
  cursor: pointer;
  color: ${({ closeIconColor }) => closeIconColor || 'white'};
`;

S.ModalBody = styled.div`
  display: flex;
  flex-direction: ${({ flexDirectionBody }) => flexDirectionBody || ''};
  border-radius: 0.42rem;
  background-color: ${({ backgroundBody }) => backgroundBody || '#fff'};
`;

export default S;
